// Styles two specific nav menu items as square CTA buttons, matching the
// Website-redesign mock: "For F&B businesses" (dark) and "Same-day order" (sage).
// The button LABEL always comes straight from Shopify Admin > Content > Menus —
// that's never touched here. What this script decides is which menu items get
// the button styling, matched primarily by link URL (stable even if the menu
// label is reworded later), falling back to link text if the URL doesn't match
// anything below — update these lists if the real URLs/wording ever change.
(function () {
  const TRADE_URL_MATCHES = ["get-started", "trade"];
  const TRADE_TEXT_MATCHES = ["for f&b businesses", "for businesses", "f&b"];
  const GRAB_URL_MATCHES = ["grab.com"];
  const GRAB_TEXT_MATCHES = ["same-day order", "same day order"];

  // Optional caption under the "For F&B businesses" button, e.g. "Open an account".
  // Editable/toggleable in the Theme Editor under Theme settings > "Nosh — Header"
  // (window.NOSH_TRADE_CAPTION, set in layout/theme.liquid) — empty string hides it.
  // Falls back to this default if that global isn't defined for some reason.
  const TRADE_CAPTION = typeof window.NOSH_TRADE_CAPTION === "string" ? window.NOSH_TRADE_CAPTION : "OPEN AN ACCOUNT WITH US";

  function hrefMatches(href, list) {
    const h = (href || "").toLowerCase();
    return list.some(m => h.includes(m));
  }
  function textMatches(text, list) {
    const t = (text || "").trim().toLowerCase();
    return list.some(m => t.includes(m));
  }

  document.addEventListener("DOMContentLoaded", function () {
    // Desktop inline menu + mobile drawer menu use different markup for the same links.
    document.querySelectorAll(".header__inline-menu .header__menu-item, .menu-drawer__menu-item").forEach(el => {
      const href = el.getAttribute("href") || "";
      const label = el.querySelector("span") || el;
      const text = label.textContent || "";

      let kind = null;
      if (hrefMatches(href, TRADE_URL_MATCHES)) kind = "trade";
      else if (hrefMatches(href, GRAB_URL_MATCHES)) kind = "grab";
      else if (textMatches(text, TRADE_TEXT_MATCHES)) kind = "trade";
      else if (textMatches(text, GRAB_TEXT_MATCHES)) kind = "grab";
      if (!kind) return;

      el.classList.add("nosh-nav-cta", `nosh-nav-cta--${kind}`);

      // GA4 click tracking, named by destination so it lines up with the
      // product-page buttons (order_on_grab / get_trade_supply) — nav_ prefix
      // keeps the two locations separate in the CTA name report. `kind` is
      // decided by URL above, so a reworded or translated menu label can't
      // change which event a link sends. gtag() is called directly because a
      // bare dataLayer.push only becomes a GA4 event if a Tag Manager
      // trigger is listening for it.
      const ctaName = kind === "trade" ? "nav_get_trade_supply" : "nav_order_on_grab";
      el.addEventListener("click", function () {
        if (typeof window.gtag === "function") {
          window.gtag("event", "cta_click", { cta_name: ctaName });
        }
        window.dataLayer = window.dataLayer || [];
        window.dataLayer.push({ event: "cta_click", cta_name: ctaName });
      });

      if (kind === "trade" && TRADE_CAPTION) {
        const caption = document.createElement("span");
        caption.className = "nosh-nav-cta-caption";
        caption.textContent = TRADE_CAPTION;
        el.insertAdjacentElement("afterend", caption);
      }
    });
  });
})();
